export default __webpack_public_path__ + "static/media/Problem.86bcc2c8.svg";